// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__26Bwg","head":"ProcedureTableInfo_head__2xffI"};